// extracted by mini-css-extract-plugin
export default {"pdf-download-container":"PdfDownload_pdf-download-container__wbhQW","pdf-download-button":"PdfDownload_pdf-download-button__nKMts"};